import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CommentaryService {

  constructor(private http: HttpClient) {
  }

  addCommentary(dealerId: number, commentary: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = 'dealers/' + dealerId + '/comments/';
    return this.http
      .post(url, commentary, { headers: headers });
  }

}
